// src/views/VehicleInspectionView/index.jsx
import React, { useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import InspectionList from '../../components/ui/list/InspectionList';
import InspectionValidator from './InspectionValidator';
import { useLayout } from '../../context/LayoutContext';
import '../../assets/scss/views/VehicleInspectionView.scss';

const VehicleInspectionView = () => {
  const { theme } = useLayout();
  const [activeTab, setActiveTab] = useState(0);
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  
  return (
    <div className={`vehicle-inspection-container-${theme}`}>
      <div className={`inspection-header-${theme}`}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          className={`inspection-tabs-${theme}`}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="inspection tabs"
        >
          <Tab label="Cargar Inspecciones" id="tab-0" aria-controls="tabpanel-0" />
          <Tab label="Ver Inspecciones" id="tab-1" aria-controls="tabpanel-1" />
        </Tabs>
      </div>
      
      <div className={`inspection-content-${theme}`} role="tabpanel">
        {activeTab === 0 && (
          <div className={`tab-panel-${theme}`} id="tabpanel-0" aria-labelledby="tab-0">
            <InspectionValidator theme={theme} />
          </div>
        )}
        {activeTab === 1 && (
          <div className={`tab-panel-${theme}`} id="tabpanel-1" aria-labelledby="tab-1">
            <InspectionList theme={theme} />
          </div>
        )}
      </div>
    </div>
  );
};

export default VehicleInspectionView;